function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import clone from '@sky-uk-ott/core-video-sdk-js-external-rfdc';
import { AdBreakEventStatus, AdBreakSource, AdBreakType, AdBreakUpdateMergeStrategy, TrackingEventType } from '../../addons/adverts/common';
import { sdkLogger } from '../../logger';
import { addNumbersAndResolvePrecision } from '../../utils/number-precision';
import { Observable } from '../../utils/observables/observable';
import { cloneAd, cloneAdBreak, getScheduledEventKeyForAd, isEmptyAdBreak, recalculateAdBreakDuration, sanitisePosition } from '../../utils/ad-break-utils';
import { fixedPointEqual } from '../../utils/float-utils';
export { AdBreakEventStatus } from './bolt-ons.enums';
import { checkIsManifestLinearType } from '../../utils/playback-type';
import { CvsdkEventCueType } from '../../core/events/event.enums';
// used for parsing paginated ad data
// The amount by which an ad break's duration can change, without being considered a new break
// This is necessary, as in some cases Media Tailor data was seen to flip flop between two very similar times
var BREAK_DURATION_CHANGE_TOLERANCE_SECONDS = 1;
var DEFAULT_BREAK_START_TOLERANCE = 0.9;
// Tolerance to prevent adBreakEnd events from firing before adEnd events
export var AD_BREAK_END_AND_LAST_AD_TOLERANCE = 0.1;
var calculateAdBreakStart = function(adBreak) {
    return adBreak.position === 'start' || adBreak.position === 'end' ? 0 : adBreak.position;
};
export var AdEventsManager = /*#__PURE__*/ function() {
    "use strict";
    function AdEventsManager(param) {
        var _this = this;
        var adPolicyManager = param.adPolicyManager, session = param.session, playbackType = param.playbackType, adBreakStartTolerance = param.adBreakStartTolerance;
        _class_call_check(this, AdEventsManager);
        var _this1 = this;
        _define_property(this, "adBreakStartedObservable", new Observable());
        _define_property(this, "adBreakFinishedObservable", new Observable());
        _define_property(this, "adBreakDataChangedObservable", new Observable());
        _define_property(this, "adStartedObservable", new Observable());
        _define_property(this, "adFinishedObservable", new Observable());
        _define_property(this, "adEventObservable", new Observable());
        _define_property(this, "adTrackingReceivedObservable", new Observable());
        _define_property(this, "adTrackingReceived", false);
        _define_property(this, "isManifestLinearType", false);
        _define_property(this, "adPolicyManager", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "adBreakStartTolerance", void 0);
        _define_property(this, "lastLiveWindow", null);
        _define_property(this, "playoutData", void 0);
        _define_property(this, "currentAdBreak", null);
        _define_property(this, "currentAd", null);
        _define_property(this, "emptyPrerollsFired", false);
        _define_property(this, "sessionInitialized", false);
        // The ad and adBreaks in memoizedEvents are the same object references as those in adBreakData - modifying one should modify the other
        _define_property(this, "memoizedEvents", {
            adEvents: {},
            adBreakEvents: {}
        });
        _define_property(this, "adBreakData", new Map());
        _define_property(this, "logger", sdkLogger.withContext('AdEventsManager'));
        _define_property(this, "onSessionStateChanged", function(state, currentPosition) {
            // Note: Any session state change confirms the SCI is attached
            if (!_this.sessionInitialized) {
                _this.sessionInitialized = true;
                _this.attachSessionEventListeners();
                _this.flushPendingEventCues();
            }
        });
        _define_property(this, "handleAdsSkipped", function(adBreakId, catchupSeek) {
            _this.adjustAdBreakStart(adBreakId, catchupSeek);
        });
        _define_property(this, "onAdBreakCueEntered", function(cue) {
            var _this_currentAdBreak;
            var adBreakId = cue.data;
            var adBreak = _this.memoizedEvents.adBreakEvents[adBreakId].adBreak;
            if (!adBreak) {
                _this.logger.warn("Expected to find adBreak with id ".concat(adBreakId, "."));
                return;
            } else if (((_this_currentAdBreak = _this.currentAdBreak) === null || _this_currentAdBreak === void 0 ? void 0 : _this_currentAdBreak.id) === adBreak.id) {
                // Note: When rescheduling ads, it's common that the cue will be re-entered again when the break is active
                return;
            }
            if (_this.currentAdBreak != null) {
                _this.logger.warn("Ad break ".concat(adBreakId, " has started when ad break ").concat(_this.currentAdBreak.id, " was already active! Unexpected behavior may occur."));
            }
            _this.currentAdBreak = adBreak;
            _this.notifyAdBreakStarted(_this.currentAdBreak);
        });
        _define_property(this, "onAdBreakCueExited", function(cue) {
            var adBreakId = cue.data;
            var adBreak = _this.memoizedEvents.adBreakEvents[adBreakId].adBreak;
            if (!adBreak) {
                _this.logger.warn("Expected to find adBreak with id ".concat(adBreakId, "."));
                return;
            }
            if (_this.currentAdBreak == null) {
                _this.logger.warn("Ad break ".concat(adBreakId, " has finished when no ad break was active! Unexpected behavior may occur."));
            }
            _this.currentAdBreak = null;
            _this.notifyAdBreakFinished(adBreak);
        });
        _define_property(this, "onAdCueEntered", function(cue) {
            var _this_memoizedEvents_adEvents_adKey, _this_currentAd;
            var adKey = cue.data;
            var ad = (_this_memoizedEvents_adEvents_adKey = _this.memoizedEvents.adEvents[adKey]) === null || _this_memoizedEvents_adEvents_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_adKey.ad;
            if (!ad) {
                _this.logger.warn("Expected to find ad with key ".concat(adKey, "."));
                return;
            } else if (((_this_currentAd = _this.currentAd) === null || _this_currentAd === void 0 ? void 0 : _this_currentAd.id) === ad.id) {
                // Note: When rescheduling ads, it's common that the cue will be re-entered again when the ad is active
                return;
            }
            if (_this.currentAdBreak == null) {
                _this.logger.warn("Ad ".concat(adKey, " has started when no ad break was active! Unexpected behavior may occur."));
            }
            if (_this.currentAd != null) {
                _this.logger.warn("Ad ".concat(adKey, " has started when ad ").concat(_this.currentAd.id, " was already active! Unexpected behavior may occur."));
            }
            _this.currentAd = ad;
            // Always couple impression and start beacons to ad start event
            _this.notifyAdEvent(adKey, TrackingEventType.AdStart);
            _this.notifyAdEvent(adKey, TrackingEventType.AdImpression);
            var clonedAd = cloneAd(ad);
            if (_this.adPolicyManager.manageAdStarted(clonedAd)) {
                _this.adStartedObservable.reset();
                _this.adStartedObservable.notifyObservers(clonedAd);
            }
        });
        _define_property(this, "onAdCueExited", function(cue) {
            var _this_memoizedEvents_adEvents_adKey;
            var adKey = cue.data;
            var ad = (_this_memoizedEvents_adEvents_adKey = _this.memoizedEvents.adEvents[adKey]) === null || _this_memoizedEvents_adEvents_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_adKey.ad;
            if (!ad) {
                _this.logger.warn("Expected to find ad with key ".concat(adKey, "."));
                return;
            }
            if (_this.currentAdBreak == null) {
                _this.logger.warn("Ad ".concat(adKey, " has finished when no ad break was active! Unexpected behavior may occur."));
            }
            if (_this.currentAd == null) {
                _this.logger.warn("Ad ".concat(adKey, " has finished when it was not marked as active! Unexpected behavior may occur."));
            } else if (_this.currentAd.id !== ad.id) {
                // Note: When the event-track implementation is eventually updated to avoid firing onCueExited events for adjacent cues in the past we can remove this block
                // For now this scenario is expected to occur frequently on live assets as ad breaks are recreated at regular intervals, so we must not notify
                _this.logger.warn("Ad ".concat(adKey, " has finished when ad ").concat(_this.currentAd.id, " was active! Unexpected behavior may occur."));
                return;
            }
            // Always couple ad finished beacons to ad finished event
            _this.notifyAdEvent(adKey, TrackingEventType.AdFinished);
            _this.currentAd = null;
            var clonedAd = cloneAd(ad);
            if (_this.adPolicyManager.manageAdFinished(clonedAd)) {
                _this.adFinishedObservable.reset();
                _this.adFinishedObservable.notifyObservers(clonedAd);
            }
        });
        _define_property(this, "onAdTrackingCueExited", function(cue) {
            var _this_memoizedEvents_adEvents_cueData_adKey;
            var cueData = cue.data;
            var ad = (_this_memoizedEvents_adEvents_cueData_adKey = _this.memoizedEvents.adEvents[cueData.adKey]) === null || _this_memoizedEvents_adEvents_cueData_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_cueData_adKey.ad;
            if (!ad) {
                _this.logger.warn("Expected to find ad with key ".concat(cueData.adKey, "."));
                return;
            }
            _this.notifyAdEvent(cueData.adKey, cueData.eventType);
        });
        _define_property(this, "notifyAdEvent", function(adKey, event) {
            var _this_memoizedEvents_adEvents_adKey;
            _this.logger.verbose('Notifying ad event:', adKey, event);
            var ad = (_this_memoizedEvents_adEvents_adKey = _this.memoizedEvents.adEvents[adKey]) === null || _this_memoizedEvents_adEvents_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_adKey.ad;
            var adBreak = _this.getAdBreak(ad === null || ad === void 0 ? void 0 : ad.adBreakId);
            if (!ad || !adBreak) {
                _this.logger.warn("Expected to find ad with key ".concat(adKey, "."));
                return;
            }
            if (_this.currentAdBreak == null) {
                _this.logger.warn("Ad event '".concat(event, "' was notified for ad ").concat(adKey, " when no ad break was active! Unexpected behavior may occur."));
            }
            if (_this.currentAd == null || getScheduledEventKeyForAd(adBreak, _this.currentAd) != adKey) {
                _this.logger.warn("Ad event '".concat(event, "' was notified for ad ").concat(adKey, " when associated ad was not marked as active! Unexpected behavior may occur."));
            }
            _this.adEventObservable.reset();
            _this.adEventObservable.notifyObservers({
                ad: ad,
                adBreak: adBreak,
                event: event,
                adKey: adKey
            });
        });
        _define_property(this, "handleAdBreakDataReceived", function(adBreakUpdate) {
            _this.logger.verbose('AdBreak data received by ad-events-manager:', adBreakUpdate);
            var sanitisedBreaks = adBreakUpdate.adBreaks.map(_this.sanitiseBreak);
            if (_this.lastLiveWindow) {
                // Do not add incoming ad break data that is already outside the live window
                sanitisedBreaks = sanitisedBreaks.filter(function(adBreak) {
                    return _this.isAdBreakInLiveWindow(adBreak, _this.lastLiveWindow);
                });
            }
            switch(adBreakUpdate.mergeStrategy){
                case AdBreakUpdateMergeStrategy.Overwrite:
                    _this.updateScheduledEventsWithReceivedAdBreaks(sanitisedBreaks);
                    break;
                case AdBreakUpdateMergeStrategy.Merge:
                default:
                    _this.updateAdBreaks(sanitisedBreaks);
                    break;
            }
            if (adBreakUpdate.adBreaks.length > 0) {
                _this.logger.info('AdBreak data updated in ad-events-manager:', _this.adBreakData);
                _this.logger.verbose('AdBreak events updated in ad-events-manager:', _this.memoizedEvents.adBreakEvents);
                _this.logger.verbose('Ad events updated in ad-events-manager:', _this.memoizedEvents.adEvents);
            }
            _this.adBreakDataChangedObservable.notifyObservers(_this.getAdBreakDataArray());
            // Only want to set tracking as received if tracking was received from the SSAI provider
            if (![
                AdBreakSource.Manifest,
                AdBreakSource.OutOfBand
            ].includes(adBreakUpdate.source)) {
                if (!_this.adTrackingReceived) {
                    _this.adTrackingReceived = true;
                    _this.adTrackingReceivedObservable.notifyObservers();
                }
            }
            _this.fireMissedEmptyPrerollEvents();
            if (_this.isManifestLinearType) {
                _this.tryCleanAdBreakData();
            }
        });
        _define_property(this, "doesRecordMatchBreak", function(sanitisedBreak, recordedAdBreakEvent) {
            var _sanitisedBreak_trackingEvents, _recordedAdBreakEvent_adBreak_trackingEvents;
            // Check if our memoized event data matches the received adBreak, if position has changed more than the threshold allows
            // then we should cancel the previous event and reschedule it with the updated data
            return sanitisedBreak.id === recordedAdBreakEvent.id && sanitisedBreak.ads.length === recordedAdBreakEvent.numOfAds && fixedPointEqual(sanitisedBreak.position, Number(recordedAdBreakEvent.position), 2) && Math.abs(sanitisedBreak.expectedDuration - recordedAdBreakEvent.duration) < BREAK_DURATION_CHANGE_TOLERANCE_SECONDS && ((_sanitisedBreak_trackingEvents = sanitisedBreak.trackingEvents) === null || _sanitisedBreak_trackingEvents === void 0 ? void 0 : _sanitisedBreak_trackingEvents.length) === ((_recordedAdBreakEvent_adBreak_trackingEvents = recordedAdBreakEvent.adBreak.trackingEvents) === null || _recordedAdBreakEvent_adBreak_trackingEvents === void 0 ? void 0 : _recordedAdBreakEvent_adBreak_trackingEvents.length);
        });
        /**
     * Takes incoming paginated AdBreak data and adds any new AdBreak objects and new tracking events (for both Ad and AdBreak) to the this.adBreakData store.
     * If new ads are found in the incoming paginated AdBreak data, they will also be added to the this.adBreakData store and the this.memoizedEvents.adEvents memo.
     * @param sanitisedBreaks incoming paginated and sanitised AdBreak data
     */ _define_property(this, "updateAdBreaks", function(sanitisedBreaks) {
            // For paginated adBreak data, we want to check and add any new tracking events on adBreaks/ads, and add any new adBreaks.
            // O(n+m) where n is num of ad breaks, m is num of ad total
            var newAdBreaksToSchedule = new Set();
            var newAdsToSchedule = new Set();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sanitisedBreaks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _ref = _step.value;
                    var incomingAdBreak = _ref;
                    var storedAdBreak = _this.memoizedEvents.adBreakEvents[incomingAdBreak.id];
                    if (!storedAdBreak) {
                        _this.logger.info('New adBreak found, adding to store: ', incomingAdBreak.id);
                        newAdBreaksToSchedule.add(incomingAdBreak);
                        continue;
                    }
                    // Add any additional new tracking events received for ad breaks and ads
                    if (incomingAdBreak.trackingEvents) {
                        if (storedAdBreak.adBreak.trackingEvents) {
                            var trackingEventSet = new Set(storedAdBreak.adBreak.trackingEvents.map(function(event) {
                                return event.url;
                            }));
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = incomingAdBreak.trackingEvents[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var incomingTrackingEvent = _step1.value;
                                    if (!trackingEventSet.has(incomingTrackingEvent.url)) {
                                        storedAdBreak.adBreak.trackingEvents.push(incomingTrackingEvent);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        } else {
                            storedAdBreak.adBreak.trackingEvents = incomingAdBreak.trackingEvents;
                        }
                    }
                    // Sync any additional ad break fields that may have been updated
                    var ads = incomingAdBreak.ads, trackingEvents = incomingAdBreak.trackingEvents, watched = incomingAdBreak.watched, remainingAdBreakProps = _object_without_properties(incomingAdBreak, [
                        "ads",
                        "trackingEvents",
                        "watched"
                    ]);
                    Object.assign(storedAdBreak.adBreak, remainingAdBreakProps);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = incomingAdBreak.ads[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var _ref1 = _step2.value;
                            var incomingAd = _ref1;
                            var adEventId = getScheduledEventKeyForAd(incomingAdBreak, incomingAd);
                            var storedAd = _this.memoizedEvents.adEvents[adEventId];
                            if (!storedAd) {
                                _this.logger.info('New ad found, adding to store: ', incomingAd.id);
                                newAdsToSchedule.add(incomingAd);
                                continue;
                            }
                            if (incomingAd.trackingEvents) {
                                if (storedAd.ad.trackingEvents) {
                                    var trackingEventSet1 = new Set(storedAd.ad.trackingEvents.map(function(event) {
                                        return event.url;
                                    }));
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(var _iterator3 = incomingAd.trackingEvents[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var incomingTrackingEvent1 = _step3.value;
                                            if (!trackingEventSet1.has(incomingTrackingEvent1.url)) {
                                                _this.memoizedEvents.adEvents[adEventId].ad.trackingEvents.push(incomingTrackingEvent1);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                } else {
                                    _this.memoizedEvents.adEvents[adEventId].ad.trackingEvents = incomingAd.trackingEvents;
                                }
                            }
                            // Sync any additional ad fields that may have been updated
                            var trackingEvents1 = incomingAd.trackingEvents, remainingAdProps = _object_without_properties(incomingAd, [
                                "trackingEvents"
                            ]);
                            Object.assign(storedAd.ad, remainingAdProps);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            // Add new ad breaks to memo and scheduler
            _to_consumable_array(newAdBreaksToSchedule).forEach(_this.storeAdBreakEvents, _this);
            _to_consumable_array(newAdsToSchedule).forEach(_this.mapAndStoreNewAdEvents, _this);
        });
        _define_property(this, "storeAdBreakEvents", function(sanitisedBreak) {
            var adBreakStartPosition = sanitisedBreak.position;
            var adBreakEndPosition = addNumbersAndResolvePrecision(adBreakStartPosition, sanitisedBreak.expectedDuration);
            var adBreakId = sanitisedBreak.id;
            _this.logger.info("Storing new ad break, id: ".concat(sanitisedBreak.id, ", position: ").concat(sanitisedBreak.position, ", duration: ").concat(sanitisedBreak.expectedDuration, ", ads: ").concat(sanitisedBreak.ads.length));
            // Note: For empty prerolls, for reliability we will trigger manually rather than relying on the cue when starting from position zero
            var deferEmptyPreroll = _this.isPlayerStartingFromZero() && _this.isEmptyPrerollAdBreak(sanitisedBreak);
            var pendingCue = {
                startTime: adBreakStartPosition === 0 ? 0 : adBreakStartPosition - _this.adBreakStartTolerance,
                endTime: adBreakEndPosition,
                type: CvsdkEventCueType.AdBreak,
                isPersistent: true,
                data: adBreakId
            };
            // If session isn't ready, defer registration for later
            var cueId = _this.sessionInitialized && !deferEmptyPreroll ? _this.session.registerCue(pendingCue) : undefined;
            var lastAdEndPosition = _this.storeAdEventsForBreak(sanitisedBreak);
            _this.adBreakData.set(adBreakId, sanitisedBreak);
            _this.memoizedEvents.adBreakEvents[adBreakId] = {
                id: adBreakId,
                adBreak: sanitisedBreak,
                position: adBreakStartPosition,
                duration: sanitisedBreak.expectedDuration,
                numOfAds: sanitisedBreak.ads.length,
                lastAdEndPosition: lastAdEndPosition,
                pendingCue: !_this.sessionInitialized && !deferEmptyPreroll ? pendingCue : undefined,
                cueId: cueId
            };
        });
        /**
     * Stores and schedules all Ads within sanitisedBreak
     * @param sanitisedBreak AdBreak with ad events to schedule and store
     * @returns position of end of last Ad scheduled for AdBreak
     */ _define_property(this, "storeAdEventsForBreak", function(sanitisedBreak) {
            var nextAdStartPosition = sanitisedBreak.position;
            var adBreakEndPosition = addNumbersAndResolvePrecision(sanitisedBreak.position, sanitisedBreak.expectedDuration);
            sanitisedBreak.ads.forEach(function(ad) {
                if (!ad) {
                    // the ad is yet to be parsed
                    return;
                }
                var adEndPosition = addNumbersAndResolvePrecision(nextAdStartPosition, ad.expectedDuration);
                // Prevent ad end event occurring after adBreakEnd
                // This can happen due to rounding errors while using `toFixed`
                adEndPosition = _this.sanitiseAdEndPosition(adEndPosition, adBreakEndPosition);
                var adKey = getScheduledEventKeyForAd(sanitisedBreak, ad);
                if (!_this.memoizedEvents.adEvents[adKey]) {
                    _this.logger.verbose('Advert at:', nextAdStartPosition);
                    _this.storeAdEvents(ad, nextAdStartPosition, adEndPosition, adKey);
                }
                nextAdStartPosition = adEndPosition;
            });
            return nextAdStartPosition;
        });
        /**
     * Intended for use with new ads being added to existing adBreaks - do not use for adding new ads in new adBreaks!
     * @param ad new Ad object to be appended to its parent adBreak object (referenced within the Ad object)
     */ _define_property(this, "mapAndStoreNewAdEvents", function(ad) {
            var parentAdBreak = _this.memoizedEvents.adBreakEvents[ad.adBreakId];
            // Sum up existing ads to get new start position
            // Calculate ad end position
            if (parentAdBreak) {
                var adEndPosition = addNumbersAndResolvePrecision(parentAdBreak.lastAdEndPosition, ad.expectedDuration);
                var adBreakEndPosition = addNumbersAndResolvePrecision(sanitisePosition(parentAdBreak.adBreak.position), parentAdBreak.adBreak.expectedDuration || 0);
                // Prevent ad end event occurring after adBreakEnd
                // This can happen due to rounding errors while using `toFixed`
                adEndPosition = _this.sanitiseAdEndPosition(adEndPosition, adBreakEndPosition);
                // Update break data
                parentAdBreak.adBreak.ads.push(ad);
                parentAdBreak.numOfAds++;
                // Store events
                _this.storeAdEvents(ad, parentAdBreak.lastAdEndPosition, adEndPosition, getScheduledEventKeyForAd(parentAdBreak.adBreak, ad));
                parentAdBreak.lastAdEndPosition = adEndPosition;
            }
        });
        // this must be updated AFTER storeAdEvents(), or ad events will be scheduled at the wrong times
        /**
     * Registers cues for ad events and ad tracking beacons
     */ _define_property(this, "storeAdEvents", function(ad, adStartPosition, adEndPosition, adKey) {
            var firstQuartileTime = adStartPosition + ad.expectedDuration * 0.25;
            var midpointTime = adStartPosition + ad.expectedDuration * 0.5;
            var thirdQuartileTime = adStartPosition + ad.expectedDuration * 0.75;
            var pendingCues = [
                {
                    startTime: adStartPosition,
                    endTime: adEndPosition,
                    type: CvsdkEventCueType.Ad,
                    isPersistent: true,
                    data: adKey
                },
                {
                    startTime: adStartPosition,
                    endTime: firstQuartileTime,
                    type: CvsdkEventCueType.AdTracking,
                    isPersistent: false,
                    data: {
                        adKey: adKey,
                        eventType: TrackingEventType.FirstQuartile
                    }
                },
                {
                    startTime: firstQuartileTime,
                    endTime: midpointTime,
                    type: CvsdkEventCueType.AdTracking,
                    isPersistent: false,
                    data: {
                        adKey: adKey,
                        eventType: TrackingEventType.Midpoint
                    }
                },
                {
                    startTime: midpointTime,
                    endTime: thirdQuartileTime,
                    type: CvsdkEventCueType.AdTracking,
                    isPersistent: false,
                    data: {
                        adKey: adKey,
                        eventType: TrackingEventType.ThirdQuartile
                    }
                }
            ];
            // If session isn't ready, defer registration for later
            var cueIds = _this.sessionInitialized ? pendingCues.map(function(cue) {
                return _this.session.registerCue(cue);
            }) : [];
            _this.memoizedEvents.adEvents[adKey] = {
                id: adKey,
                ad: ad,
                adEventCueId: cueIds,
                pendingCues: !_this.sessionInitialized ? pendingCues : undefined,
                cueIds: cueIds
            };
        });
        _define_property(this, "sanitiseBreak", function(adBreak) {
            var clonedAdBreak = cloneAdBreak(adBreak);
            var _adBreak_expectedDuration;
            clonedAdBreak.expectedDuration = (_adBreak_expectedDuration = adBreak.expectedDuration) !== null && _adBreak_expectedDuration !== void 0 ? _adBreak_expectedDuration : recalculateAdBreakDuration(clonedAdBreak);
            clonedAdBreak.position = sanitisePosition(adBreak.position);
            return clonedAdBreak;
        });
        _define_property(this, "tryCleanAdBreakData", /*#__PURE__*/ _async_to_generator(function() {
            var liveWindow;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this1.session.getLiveWindow()
                        ];
                    case 1:
                        liveWindow = _state.sent();
                        if (liveWindow) {
                            _this1.lastLiveWindow = liveWindow;
                            _this1.cleanAdBreaks(liveWindow);
                        }
                        return [
                            2
                        ];
                }
            });
        }));
        /**
     * Prevents ad end events from being scheduled and firing after adBreakEnd events.
     * @param adEndPosition
     * @param adBreakEndPosition
     * @returns position for ad end that guarantees positioning before adBreak end
     */ _define_property(this, "sanitiseAdEndPosition", function(adEndPosition, adBreakEndPosition) {
            if (adEndPosition < adBreakEndPosition) {
                return adEndPosition;
            } else {
                return adBreakEndPosition - AD_BREAK_END_AND_LAST_AD_TOLERANCE;
            }
        });
        this.adPolicyManager = adPolicyManager;
        this.session = session;
        this.adBreakStartTolerance = adBreakStartTolerance !== null && adBreakStartTolerance !== void 0 ? adBreakStartTolerance : DEFAULT_BREAK_START_TOLERANCE;
        this.isManifestLinearType = checkIsManifestLinearType(playbackType);
        this.session.onStateChanged(this.onSessionStateChanged);
    }
    _create_class(AdEventsManager, [
        {
            key: "attachSessionEventListeners",
            value: function attachSessionEventListeners() {
                // Note: EventCue priority will determine true order, but this outlines the expected order of handling cue events
                this.session.onEventCueEntered(CvsdkEventCueType.AdBreak, this.onAdBreakCueEntered);
                this.session.onEventCueEntered(CvsdkEventCueType.Ad, this.onAdCueEntered);
                this.session.onEventCueExited(CvsdkEventCueType.AdTracking, this.onAdTrackingCueExited);
                this.session.onEventCueExited(CvsdkEventCueType.Ad, this.onAdCueExited);
                this.session.onEventCueExited(CvsdkEventCueType.AdBreak, this.onAdBreakCueExited);
            }
        },
        {
            key: "flushPendingEventCues",
            value: /**
     * Processes all pending event registration cues.
     */ function flushPendingEventCues() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Register all deferred cues and purge memory
                    for(var _iterator = this.adBreakData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), _ = _step_value[0], adBreak = _step_value[1];
                        var adBreakEvent = this.memoizedEvents.adBreakEvents[adBreak.id];
                        var pendingAdBreakCue = adBreakEvent === null || adBreakEvent === void 0 ? void 0 : adBreakEvent.pendingCue;
                        if (pendingAdBreakCue) {
                            adBreakEvent.cueId = this.session.registerCue(pendingAdBreakCue);
                            delete this.memoizedEvents.adBreakEvents[adBreak.id].pendingCue;
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            var _this1, _loop = function() {
                                var ad = _step1.value;
                                var adKey = getScheduledEventKeyForAd(adBreak, ad);
                                var adEvent = _this1.memoizedEvents.adEvents[adKey];
                                var pendingAdCues = adEvent === null || adEvent === void 0 ? void 0 : adEvent.pendingCues;
                                if (pendingAdCues) {
                                    pendingAdCues.forEach(function(pendingAdCue) {
                                        adEvent.cueIds.push(_this.session.registerCue(pendingAdCue));
                                    });
                                    delete _this1.memoizedEvents.adEvents[adKey].pendingCues;
                                }
                            };
                            for(var _iterator1 = adBreak.ads[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_this1 = this, _loop();
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getCurrentAdBreak",
            value: function getCurrentAdBreak() {
                return this.currentAdBreak;
            }
        },
        {
            key: "getCurrentAd",
            value: function getCurrentAd() {
                return this.currentAd;
            }
        },
        {
            key: "onAdBreakStarted",
            value: function onAdBreakStarted(listener, ctx) {
                this.adBreakStartedObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdBreakFinished",
            value: function onAdBreakFinished(listener, ctx) {
                this.adBreakFinishedObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdStarted",
            value: function onAdStarted(listener, ctx) {
                this.adStartedObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdFinished",
            value: function onAdFinished(listener, ctx) {
                this.adFinishedObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdEvent",
            value: function onAdEvent(listener, ctx) {
                this.adEventObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdTrackingReceived",
            value: function onAdTrackingReceived(listener, ctx) {
                this.adTrackingReceivedObservable.registerObserver(listener, ctx);
            }
        },
        {
            key: "onAdBreakDataChanged",
            value: function onAdBreakDataChanged(callback, ctx) {
                this.adBreakDataChangedObservable.registerObserver(callback, ctx);
            }
        },
        {
            key: "setPlayoutData",
            value: function setPlayoutData(playoutData) {
                this.playoutData = playoutData;
            }
        },
        {
            key: "isPlayerStartingFromZero",
            value: function isPlayerStartingFromZero() {
                return Boolean(this.playoutData && (this.playoutData.position === undefined || this.playoutData.position === 0));
            }
        },
        {
            key: "isEmptyPrerollAdBreak",
            value: function isEmptyPrerollAdBreak(adBreak) {
                var isEmpty = isEmptyAdBreak(adBreak);
                return adBreak.type === AdBreakType.Preroll && isEmpty;
            }
        },
        {
            key: "adjustAdBreakStart",
            value: /**
     * In the event of a ad-skip-to-catchup (on lower performing devices, one or more ads in an adBreak may be skipped to catch up playback with the live edge),
     * this method reschedules the adBreak start event to the first ad start time AFTER the skips are performed.
     * @param adBreak - base adBreak object containing ads, some of which will be skipped
     * @param catchupSeek - object describing skip behavior decided by ad-policy-manager
     */ function adjustAdBreakStart(adBreakId, catchupSeek) {
                var adBreakEvent = this.memoizedEvents.adBreakEvents[adBreakId];
                if (!adBreakEvent || catchupSeek.index !== 0 || catchupSeek.duration >= adBreakEvent.adBreak.expectedDuration) {
                    // Do nothing if the first ad is not skipped and BreakStart event has been fired naturally
                    // or if the entire ad break is skipped
                    return;
                }
                var adBreak = adBreakEvent.adBreak;
                var adBreakStartPosition = calculateAdBreakStart(adBreak);
                var adBreakNewStartPosition = adBreakStartPosition + catchupSeek.duration;
                var adBreakEndPosition = addNumbersAndResolvePrecision(adBreakNewStartPosition, adBreak.expectedDuration);
                if (adBreakEvent.cueId) {
                    this.session.unregisterCue(adBreakEvent.cueId);
                }
                var pendingCue = {
                    startTime: adBreakNewStartPosition === 0 ? 0 : adBreakNewStartPosition - this.adBreakStartTolerance,
                    endTime: adBreakEndPosition,
                    type: CvsdkEventCueType.AdBreak,
                    isPersistent: true,
                    data: adBreakId
                };
                var adBreakCueId = this.sessionInitialized ? this.session.registerCue(pendingCue) : undefined;
                adBreakEvent.pendingCue = !this.sessionInitialized ? pendingCue : undefined;
                adBreakEvent.cueId = adBreakCueId;
            }
        },
        {
            key: "getAdBreakDataArray",
            value: function getAdBreakDataArray() {
                var unsortedAdBreakData = clone({})(Array.from(this.adBreakData, function(param) {
                    var _param = _sliced_to_array(param, 2), _ = _param[0], value = _param[1];
                    return value;
                }));
                // Note: For safety, ad breaks should be sorted. This should not be too expensive since in most cases the list will already be sorted.
                unsortedAdBreakData.sort(function(a, b) {
                    return a.position - b.position;
                });
                return unsortedAdBreakData;
            }
        },
        {
            key: "getAdBreak",
            value: function getAdBreak(id) {
                return this.adBreakData.get(id);
            }
        },
        {
            key: "getAd",
            value: function getAd(adKey) {
                var _this_memoizedEvents_adEvents_adKey;
                return (_this_memoizedEvents_adEvents_adKey = this.memoizedEvents.adEvents[adKey]) === null || _this_memoizedEvents_adEvents_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_adKey.ad;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.unregisterEventCues();
                this.adBreakData = new Map();
                this.memoizedEvents = {
                    adEvents: {},
                    adBreakEvents: {}
                };
            }
        },
        {
            key: "unregisterEventCues",
            value: function unregisterEventCues() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this.memoizedEvents.adBreakEvents)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), _ = _step_value[0], adBreakEvent = _step_value[1];
                        if (adBreakEvent.cueId !== undefined) {
                            this.session.unregisterCue(adBreakEvent.cueId);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = Object.entries(this.memoizedEvents.adEvents)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = _sliced_to_array(_step1.value, 2), _1 = _step_value1[0], adEvent = _step_value1[1];
                        adEvent.cueIds.forEach(function(cueId) {
                            return _this.session.unregisterCue(cueId);
                        });
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(ctx) {
                this.adBreakStartedObservable.unregisterObservers(ctx);
                this.adBreakFinishedObservable.unregisterObservers(ctx);
                this.adStartedObservable.unregisterObservers(ctx);
                this.adFinishedObservable.unregisterObservers(ctx);
                this.adTrackingReceivedObservable.unregisterObservers(ctx);
            }
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted(adBreak) {
                var clonedAdBreak = cloneAdBreak(adBreak);
                if (this.adPolicyManager.manageAdBreakStarted(clonedAdBreak)) {
                    this.adBreakStartedObservable.reset();
                    this.adBreakStartedObservable.notifyObservers(clonedAdBreak);
                }
            }
        },
        {
            key: "notifyAdBreakFinished",
            value: function notifyAdBreakFinished(adBreak) {
                var wasWatched = adBreak.watched;
                // Note: Ad breaks must be cloned in order to not expose the internal copy
                var clonedAdBreak = cloneAdBreak(adBreak);
                if (this.adPolicyManager.manageAdBreakFinished(clonedAdBreak)) {
                    this.adBreakFinishedObservable.reset();
                    this.adBreakFinishedObservable.notifyObservers(clonedAdBreak);
                    if (!wasWatched) {
                        adBreak.watched = true;
                        this.adBreakDataChangedObservable.notifyObservers(this.getAdBreakDataArray());
                    }
                }
            }
        },
        {
            key: "fireMissedEmptyPrerollEvents",
            value: function fireMissedEmptyPrerollEvents() {
                if (this.emptyPrerollsFired) {
                    return;
                }
                this.emptyPrerollsFired = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.adBreakData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _sliced_to_array(_step.value, 2), _ = _step_value[0], adBreak = _step_value[1];
                        // Explicitly notify empty prerolls
                        if (this.isPlayerStartingFromZero() && this.isEmptyPrerollAdBreak(adBreak)) {
                            this.notifyAdBreakStarted(adBreak);
                            this.notifyAdBreakFinished(adBreak);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "updateScheduledEventsWithReceivedAdBreaks",
            value: /**
     * Takes incoming ad breaks - looks at events to cancels/reschedule for updated ads, filters new unseen ads, returns lists of ads to cancel and add as a "summarized delta"
     * @param sanitisedBreaks
     */ function updateScheduledEventsWithReceivedAdBreaks(sanitisedBreaks) {
                var _this = this;
                var scheduledEventsToCancel = new Set();
                var newAdBreaks = new Set();
                var seenAdBreakIds = new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var currentBreak = _step.value;
                        var previouslySeenBreakEvent = _this1.memoizedEvents.adBreakEvents[currentBreak.id];
                        seenAdBreakIds.add(currentBreak.id);
                        switch(_this1.getBreakEventStatus(currentBreak, previouslySeenBreakEvent)){
                            case AdBreakEventStatus.NEW_BREAK:
                                newAdBreaks.add(currentBreak);
                                break;
                            case AdBreakEventStatus.ACTIVE_BREAK:
                                // We should always track updated adBreak and ad data (while maintaining watched status)
                                currentBreak.watched = previouslySeenBreakEvent.adBreak.watched;
                                _this1.memoizedEvents.adBreakEvents[currentBreak.id].adBreak = currentBreak;
                                _this1.adBreakData.set(currentBreak.id, currentBreak);
                                currentBreak.ads.forEach(function(newAdData) {
                                    var adKey = getScheduledEventKeyForAd(currentBreak, newAdData);
                                    _this.memoizedEvents.adEvents[adKey].ad = newAdData;
                                });
                                break;
                            case AdBreakEventStatus.UPDATED_BREAK:
                                // Retain watched status and reschedule the break
                                currentBreak.watched = previouslySeenBreakEvent.adBreak.watched;
                                scheduledEventsToCancel.add(previouslySeenBreakEvent);
                                newAdBreaks.add(currentBreak);
                                break;
                        }
                    };
                    // Classify the received adBreaks as NEW, ACTIVE, or UPDATED
                    for(var _iterator = sanitisedBreaks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Cancel any events that were previously scheduled if we did not get a corresponding adBreakId
                    for(var _iterator1 = Object.values(this.memoizedEvents.adBreakEvents)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var previousEvent = _step1.value;
                        if (!seenAdBreakIds.has(previousEvent.adBreak.id)) {
                            scheduledEventsToCancel.add(previousEvent);
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                _to_consumable_array(scheduledEventsToCancel).forEach(this.cancelScheduledAdBreakAndAdEvents, this);
                _to_consumable_array(newAdBreaks).forEach(this.storeAdBreakEvents, this);
            }
        },
        {
            key: "getBreakEventStatus",
            value: function getBreakEventStatus(currentBreak, recordedEventForAdBreak) {
                if (recordedEventForAdBreak === undefined) {
                    return AdBreakEventStatus.NEW_BREAK;
                } else if (this.doesRecordMatchBreak(currentBreak, recordedEventForAdBreak)) {
                    return AdBreakEventStatus.ACTIVE_BREAK;
                } else {
                    return AdBreakEventStatus.UPDATED_BREAK;
                }
            }
        },
        {
            key: "cancelScheduledAdBreakAndAdEvents",
            value: function cancelScheduledAdBreakAndAdEvents(scheduledAdBreakEvent) {
                var _this = this;
                this.logger.info("Removing scheduled ad break, id: ".concat(scheduledAdBreakEvent.id, ", position: ").concat(scheduledAdBreakEvent.position, ", duration: ").concat(scheduledAdBreakEvent.duration));
                if (scheduledAdBreakEvent.cueId) {
                    this.session.unregisterCue(scheduledAdBreakEvent.cueId);
                }
                // Remove any previously scheduled Ads for the AdBreak
                Object.values(this.memoizedEvents.adEvents).filter(function(recordedAdEvent) {
                    return recordedAdEvent.ad.adBreakId === scheduledAdBreakEvent.adBreak.id;
                }).map(function(recordedAdEvent) {
                    _this.logger.info("Removing scheduled ad, id: ".concat(recordedAdEvent.id));
                    recordedAdEvent.cueIds.forEach(function(cueId) {
                        _this.session.unregisterCue(cueId);
                    });
                    delete _this.memoizedEvents.adEvents[recordedAdEvent.id];
                });
                delete this.memoizedEvents.adBreakEvents[scheduledAdBreakEvent.id];
            }
        },
        {
            key: "cleanAdBreaks",
            value: /**
     * Removes ad breaks and ads from internal ad state if they fall before the provided LiveWindow
     * @param window current LiveWindow
     */ function cleanAdBreaks(liveWindow) {
                var _this = this;
                var adBreakRemoved = false;
                this.adBreakData.forEach(function(adBreak) {
                    var adBreakStart = calculateAdBreakStart(adBreak);
                    var validAdBreakStart = adBreakStart === 0 || adBreakStart;
                    // check that adBreakStart is defined, but do not reject if = 0
                    if (!validAdBreakStart || !adBreak.expectedDuration || !adBreak.watched) {
                        return;
                    }
                    if (!_this.isAdBreakInLiveWindow(adBreak, liveWindow)) {
                        var _this_memoizedEvents_adBreakEvents_adBreak_id;
                        var adBreakCueId = (_this_memoizedEvents_adBreakEvents_adBreak_id = _this.memoizedEvents.adBreakEvents[adBreak.id]) === null || _this_memoizedEvents_adBreakEvents_adBreak_id === void 0 ? void 0 : _this_memoizedEvents_adBreakEvents_adBreak_id.cueId;
                        if (adBreakCueId) {
                            _this.session.unregisterCue(adBreakCueId);
                        } else {
                            _this.logger.warn("Expected to find cue id for adBreak ".concat(adBreak.id));
                        }
                        adBreak.ads.forEach(function(ad) {
                            var _this_memoizedEvents_adEvents_adKey;
                            var adKey = getScheduledEventKeyForAd(adBreak, ad);
                            if (!_this.memoizedEvents.adEvents[adKey]) {
                                _this.logger.warn("Expected to find adEvent cue id for key ".concat(adKey, "."));
                            }
                            (_this_memoizedEvents_adEvents_adKey = _this.memoizedEvents.adEvents[adKey]) === null || _this_memoizedEvents_adEvents_adKey === void 0 ? void 0 : _this_memoizedEvents_adEvents_adKey.cueIds.forEach(function(cueId) {
                                _this.session.unregisterCue(cueId);
                            });
                            delete _this.memoizedEvents.adEvents[adKey];
                        });
                        delete _this.memoizedEvents.adBreakEvents[adBreak.id];
                        _this.adBreakData.delete(adBreak.id);
                        adBreakRemoved = true;
                        _this.logger.verbose("Clearing adBreak ".concat(adBreak.id, " from ad-events-manager state. (window start: ").concat(liveWindow.start, ")"));
                    }
                });
                if (adBreakRemoved) {
                    this.adBreakDataChangedObservable.notifyObservers(this.getAdBreakDataArray());
                }
            }
        },
        {
            key: "isAdBreakInLiveWindow",
            value: function isAdBreakInLiveWindow(adBreak, liveWindow) {
                var adBreakStart = calculateAdBreakStart(adBreak);
                if (adBreakStart) {
                    return adBreakStart + (adBreak.expectedDuration || 0) >= liveWindow.start;
                }
                return false;
            }
        }
    ]);
    return AdEventsManager;
}();

//# sourceMappingURL=ad-events-manager.js.map